/** Стиль-пак «cinematic-photo» — свой кусок каталога (WEB-2534: браузер покупателя грузит только пак своей воронки). */
import type { StylePack } from '../stylePack.types';

export const pack: StylePack = {
  id: 'cinematic-photo',
  shape: {
    radiusCard: 16, radiusOption: 16, radiusButton: 'pill', radiusImage: 0,
    borderWidth: 0, borderTone: 'none', selectionMode: 'border', shadow: 'none',
  },
  density: { optionHeight: 72, optionPadY: 24, optionPadX: 24, gap: 24, contentMaxWidth: 440, screenPadX: 24 },
  type: {
    headingFamily: 'sans', h1Size: 20, h1Weight: 400, h1Tracking: 0,
    qSize: 20, qWeight: 400, qTracking: 0, optionSize: 16, optionWeight: 500,
    headingAlign: 'center', overlineTransform: 'none',
  },
  chrome: { progress: 'none', progressLabel: 'none', counter: false, backButton: 'none', logo: 'left' },
  cta: { placement: 'none', fullWidth: true, height: 56, disabledStyle: 'grey' },
  states: { selected: 'filled', hoverTint: false, transitionMs: 200, screenFadeMs: 0 },
  imagery: {
    optionCard: 'none', overlayTone: 'none', frame: 'none',
    promptHint: 'cinematic dark photo, single directional light source, muted palette, full-bleed composition',
  },
  // Asana Rebel: фото на весь экран, текст и плитки прижаты к низу —
  // ровно тот случай, ради которого нижний градиент и существует.
  layout: { alignY: 'bottom', alignX: 'center', backgroundOverlay: 'scrim-bottom' },
  // Asana Rebel: поверх полноэкранного фото список текстовых стадий не
  // читается — работает только крупное кольцо с процентом.
  loader: {
    style: 'ring', showPercent: true, socialProof: 'review',
    answersSummary: false, engagementModals: true,
  },
  // Asana Rebel: оффер — пробный период целиком, поэтому ни таймера, ни
  // промо-кода (два оффера сразу гасят друг друга). Поверх фото читается
  // только один тариф: невыбранные гасятся, sticky-CTA с glow держит действие.
  paywall: {
    timer: 'none', promoTicket: 'none', priceMode: 'trial-total',
    planHighlight: 'chip-on-border', dimUnselectedPlans: true,
    stickyHeader: true, repeatPurchaseBlock: false,
  },
  // Зелёный CTA пака сам работает «деньгами/безопасностью», премиум — на
  // вторичном акценте палитры.
  accents: { money: 'success', premium: 'accent' },
};
